import { fetchAuthSession } from "aws-amplify/auth";

export async function getTokenData() {
  try {
    const session = await fetchAuthSession({ forceRefresh: false });

    return {
      token: session?.tokens?.accessToken?.toString() || null,
      client_id: session?.tokens?.idToken?.toString() || null,
    };
  } catch (err) {
    console.error("Erro ao obter sessão:", err);

    return {
      token: null,
      client_id: null,
    };
  }
}
